import { FC } from 'react';
import styled from 'styled-components';
import { Body2 } from 'ui/theme';
import { useListContext } from './ListContext';

export const Footer = styled.div`
  border-top: ${(props) => props.theme.spacing.values.single} solid
    ${(props) => props.theme.colors.neutrals.grey15};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: 'itemCount additionalText';
  grid-area: footer;
  padding: ${(props) => props.theme.spacing.values.base};
  width: 100%;
`;

export const FooterText = styled(Body2)`
  color: ${(props) => props.theme.colors.textColors.textSecondary};
  margin: 0;
`;

export const ItemCount = styled(FooterText)`
  grid-area: itemCount;
`;

const AdditionalText = styled(FooterText)`
  grid-area: additionalText;
`;

export const ListFooter: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  // TODO Update
  const { currentCount, totalCount } = useListContext();

  if ((currentCount ?? 0) <= 5) return null;

  return (
    <Footer>
      <ItemCount>{`Showing ${currentCount} of ${totalCount}`}</ItemCount>
      <AdditionalText>{children}</AdditionalText>
    </Footer>
  );
};
